var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanner1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 640.814,
    height: 446.351,
    viewBox: "0 0 640.814 446.351",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1088",
    "data-name": "Group 1088",
    transform: "translate(-43.912 -1747.203)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_521",
    "data-name": "Ellipse 521",
    cx: 222.85,
    cy: 222.85,
    r: 222.85,
    transform: "translate(239.026 1747.203)",
    fill: "#b1ef06"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1071",
    "data-name": "Group 1071",
    transform: "translate(43.912 1922.738)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_430",
    "data-name": "Rectangle 430",
    width: 77.54,
    height: 150.963,
    transform: "translate(262.797 119.853)",
    fill: "#d4e0f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M225.964,1911.573v-11.705H189.281v11.705H175.559v228.8h64.127v-228.8Z",
    transform: "translate(1.74 -1869.797)",
    fill: "#a4b7d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_431",
    "data-name": "Rectangle 431",
    width: 82.542,
    height: 144.973,
    transform: "translate(20.208 125.843)",
    fill: "#a4b7d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M188.143,1926.4v-29.282l-14.769-2.606V1877.54H137.406v16.976l-14.77,2.606V1926.4H102.27v221.951H208.509V1926.4Z",
    transform: "translate(-23.675 -1877.54)",
    fill: "#bfcae2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_942",
    "data-name": "Group 942",
    transform: "translate(87.88 26.295)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_823",
    "data-name": "Group 823",
    transform: "translate(1.179 57.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_820",
    "data-name": "Group 820"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_432",
    "data-name": "Rectangle 432",
    width: 11.272,
    height: 8.178,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_433",
    "data-name": "Rectangle 433",
    width: 11.274,
    height: 8.178,
    transform: "translate(19.351)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_434",
    "data-name": "Rectangle 434",
    width: 11.273,
    height: 8.178,
    transform: "translate(38.395)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_435",
    "data-name": "Rectangle 435",
    width: 11.272,
    height: 8.178,
    transform: "translate(57.746)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_436",
    "data-name": "Rectangle 436",
    width: 11.272,
    height: 8.178,
    transform: "translate(76.791)",
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_821",
    "data-name": "Group 821",
    transform: "translate(0 11.055)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_437",
    "data-name": "Rectangle 437",
    width: 11.272,
    height: 8.178,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_438",
    "data-name": "Rectangle 438",
    width: 11.274,
    height: 8.178,
    transform: "translate(19.351)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_439",
    "data-name": "Rectangle 439",
    width: 11.273,
    height: 8.178,
    transform: "translate(38.395)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_440",
    "data-name": "Rectangle 440",
    width: 11.272,
    height: 8.178,
    transform: "translate(57.746)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_441",
    "data-name": "Rectangle 441",
    width: 11.272,
    height: 8.178,
    transform: "translate(76.791)",
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_822",
    "data-name": "Group 822",
    transform: "translate(0 22.565)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_442",
    "data-name": "Rectangle 442",
    width: 11.272,
    height: 8.179,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_443",
    "data-name": "Rectangle 443",
    width: 11.274,
    height: 8.179,
    transform: "translate(19.351)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_444",
    "data-name": "Rectangle 444",
    width: 11.273,
    height: 8.179,
    transform: "translate(38.395)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_445",
    "data-name": "Rectangle 445",
    width: 11.272,
    height: 8.179,
    transform: "translate(57.746)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_446",
    "data-name": "Rectangle 446",
    width: 11.272,
    height: 8.179,
    transform: "translate(76.791)",
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_852",
    "data-name": "Group 852",
    transform: "translate(0 63.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_828",
    "data-name": "Group 828",
    transform: "translate(76.79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_827",
    "data-name": "Group 827"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_824",
    "data-name": "Group 824"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_447",
    "data-name": "Rectangle 447",
    width: 13.631,
    height: 2.121,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_825",
    "data-name": "Group 825",
    transform: "translate(0 11.207)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_448",
    "data-name": "Rectangle 448",
    width: 13.631,
    height: 1.969,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_826",
    "data-name": "Group 826",
    transform: "translate(0 22.565)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_449",
    "data-name": "Rectangle 449",
    width: 13.631,
    height: 2.122,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_833",
    "data-name": "Group 833",
    transform: "translate(57.745)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_832",
    "data-name": "Group 832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_829",
    "data-name": "Group 829"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_450",
    "data-name": "Rectangle 450",
    width: 13.631,
    height: 2.121,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_830",
    "data-name": "Group 830",
    transform: "translate(0 11.207)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_451",
    "data-name": "Rectangle 451",
    width: 13.631,
    height: 1.969,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_831",
    "data-name": "Group 831",
    transform: "translate(0 22.565)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_452",
    "data-name": "Rectangle 452",
    width: 13.631,
    height: 2.122,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_838",
    "data-name": "Group 838",
    transform: "translate(38.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_837",
    "data-name": "Group 837"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_834",
    "data-name": "Group 834"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_453",
    "data-name": "Rectangle 453",
    width: 13.63,
    height: 2.121,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_835",
    "data-name": "Group 835",
    transform: "translate(0 11.207)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_454",
    "data-name": "Rectangle 454",
    width: 13.63,
    height: 1.969,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_836",
    "data-name": "Group 836",
    transform: "translate(0 22.565)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_455",
    "data-name": "Rectangle 455",
    width: 13.63,
    height: 2.122,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_843",
    "data-name": "Group 843",
    transform: "translate(19.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_842",
    "data-name": "Group 842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_839",
    "data-name": "Group 839"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_456",
    "data-name": "Rectangle 456",
    width: 13.63,
    height: 2.121,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_840",
    "data-name": "Group 840",
    transform: "translate(0 11.207)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_457",
    "data-name": "Rectangle 457",
    width: 13.63,
    height: 1.969,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_841",
    "data-name": "Group 841",
    transform: "translate(0 22.565)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_458",
    "data-name": "Rectangle 458",
    width: 13.63,
    height: 2.122,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_851",
    "data-name": "Group 851"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_850",
    "data-name": "Group 850"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_845",
    "data-name": "Group 845"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_844",
    "data-name": "Group 844"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_459",
    "data-name": "Rectangle 459",
    width: 13.63,
    height: 2.121,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_847",
    "data-name": "Group 847",
    transform: "translate(0 11.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_846",
    "data-name": "Group 846"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_460",
    "data-name": "Rectangle 460",
    width: 13.63,
    height: 1.969,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_849",
    "data-name": "Group 849",
    transform: "translate(0 22.565)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_848",
    "data-name": "Group 848"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_461",
    "data-name": "Rectangle 461",
    width: 13.63,
    height: 2.122,
    fill: "#84c3f7"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_856",
    "data-name": "Group 856",
    transform: "translate(21.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_853",
    "data-name": "Group 853"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_462",
    "data-name": "Rectangle 462",
    width: 10.344,
    height: 7.505,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_463",
    "data-name": "Rectangle 463",
    width: 10.344,
    height: 7.505,
    transform: "translate(17.76)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_464",
    "data-name": "Rectangle 464",
    width: 10.344,
    height: 7.505,
    transform: "translate(35.236)",
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_854",
    "data-name": "Group 854",
    transform: "translate(0 10.145)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_465",
    "data-name": "Rectangle 465",
    width: 10.344,
    height: 7.504,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_466",
    "data-name": "Rectangle 466",
    width: 10.344,
    height: 7.504,
    transform: "translate(17.76)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_467",
    "data-name": "Rectangle 467",
    width: 10.344,
    height: 7.504,
    transform: "translate(35.236)",
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_855",
    "data-name": "Group 855",
    transform: "translate(0 20.707)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_468",
    "data-name": "Rectangle 468",
    width: 10.344,
    height: 7.506,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_469",
    "data-name": "Rectangle 469",
    width: 10.344,
    height: 7.506,
    transform: "translate(17.76)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_470",
    "data-name": "Rectangle 470",
    width: 10.344,
    height: 7.506,
    transform: "translate(35.236)",
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_875",
    "data-name": "Group 875",
    transform: "translate(20.27 5.558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_861",
    "data-name": "Group 861",
    transform: "translate(35.235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_860",
    "data-name": "Group 860"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_857",
    "data-name": "Group 857"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_471",
    "data-name": "Rectangle 471",
    width: 12.507,
    height: 1.947,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_858",
    "data-name": "Group 858",
    transform: "translate(0 10.284)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_472",
    "data-name": "Rectangle 472",
    width: 12.507,
    height: 1.807,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_859",
    "data-name": "Group 859",
    transform: "translate(0 20.708)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_473",
    "data-name": "Rectangle 473",
    width: 12.507,
    height: 1.946,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_866",
    "data-name": "Group 866",
    transform: "translate(17.759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_865",
    "data-name": "Group 865"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_862",
    "data-name": "Group 862"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_474",
    "data-name": "Rectangle 474",
    width: 12.509,
    height: 1.947,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_863",
    "data-name": "Group 863",
    transform: "translate(0 10.284)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_475",
    "data-name": "Rectangle 475",
    width: 12.509,
    height: 1.807,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_864",
    "data-name": "Group 864",
    transform: "translate(0 20.708)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_476",
    "data-name": "Rectangle 476",
    width: 12.509,
    height: 1.946,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_874",
    "data-name": "Group 874"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_873",
    "data-name": "Group 873"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_868",
    "data-name": "Group 868"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_867",
    "data-name": "Group 867"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_477",
    "data-name": "Rectangle 477",
    width: 12.509,
    height: 1.947,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_870",
    "data-name": "Group 870",
    transform: "translate(0 10.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_869",
    "data-name": "Group 869"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_478",
    "data-name": "Rectangle 478",
    width: 12.509,
    height: 1.807,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_872",
    "data-name": "Group 872",
    transform: "translate(0 20.708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_871",
    "data-name": "Group 871"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_479",
    "data-name": "Rectangle 479",
    width: 12.509,
    height: 1.946,
    fill: "#84c3f7"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_879",
    "data-name": "Group 879",
    transform: "translate(1.179 93.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_876",
    "data-name": "Group 876"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_480",
    "data-name": "Rectangle 480",
    width: 11.272,
    height: 8.179,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_481",
    "data-name": "Rectangle 481",
    width: 11.274,
    height: 8.179,
    transform: "translate(19.351)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_482",
    "data-name": "Rectangle 482",
    width: 11.273,
    height: 8.179,
    transform: "translate(38.395)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_483",
    "data-name": "Rectangle 483",
    width: 11.272,
    height: 8.179,
    transform: "translate(57.746)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_484",
    "data-name": "Rectangle 484",
    width: 11.272,
    height: 8.179,
    transform: "translate(76.791)",
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_877",
    "data-name": "Group 877",
    transform: "translate(0 11.056)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_485",
    "data-name": "Rectangle 485",
    width: 11.272,
    height: 8.177,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_486",
    "data-name": "Rectangle 486",
    width: 11.274,
    height: 8.177,
    transform: "translate(19.351)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_487",
    "data-name": "Rectangle 487",
    width: 11.273,
    height: 8.177,
    transform: "translate(38.395)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_488",
    "data-name": "Rectangle 488",
    width: 11.272,
    height: 8.177,
    transform: "translate(57.746)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_489",
    "data-name": "Rectangle 489",
    width: 11.272,
    height: 8.177,
    transform: "translate(76.791)",
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_878",
    "data-name": "Group 878",
    transform: "translate(0 22.564)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_490",
    "data-name": "Rectangle 490",
    width: 11.272,
    height: 8.18,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_491",
    "data-name": "Rectangle 491",
    width: 11.274,
    height: 8.18,
    transform: "translate(19.351)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_492",
    "data-name": "Rectangle 492",
    width: 11.273,
    height: 8.18,
    transform: "translate(38.395)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_493",
    "data-name": "Rectangle 493",
    width: 11.272,
    height: 8.18,
    transform: "translate(57.746)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_494",
    "data-name": "Rectangle 494",
    width: 11.272,
    height: 8.18,
    transform: "translate(76.791)",
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_908",
    "data-name": "Group 908",
    transform: "translate(0 100.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_884",
    "data-name": "Group 884",
    transform: "translate(76.79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_883",
    "data-name": "Group 883"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_880",
    "data-name": "Group 880"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_495",
    "data-name": "Rectangle 495",
    width: 13.631,
    height: 2.122,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_881",
    "data-name": "Group 881",
    transform: "translate(0 11.207)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_496",
    "data-name": "Rectangle 496",
    width: 13.631,
    height: 1.969,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_882",
    "data-name": "Group 882",
    transform: "translate(0 22.565)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_497",
    "data-name": "Rectangle 497",
    width: 13.631,
    height: 2.122,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_889",
    "data-name": "Group 889",
    transform: "translate(57.745)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_888",
    "data-name": "Group 888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_885",
    "data-name": "Group 885"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_498",
    "data-name": "Rectangle 498",
    width: 13.631,
    height: 2.122,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_886",
    "data-name": "Group 886",
    transform: "translate(0 11.207)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_499",
    "data-name": "Rectangle 499",
    width: 13.631,
    height: 1.969,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_887",
    "data-name": "Group 887",
    transform: "translate(0 22.565)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_500",
    "data-name": "Rectangle 500",
    width: 13.631,
    height: 2.122,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_894",
    "data-name": "Group 894",
    transform: "translate(38.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_893",
    "data-name": "Group 893"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_890",
    "data-name": "Group 890"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_501",
    "data-name": "Rectangle 501",
    width: 13.63,
    height: 2.122,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_891",
    "data-name": "Group 891",
    transform: "translate(0 11.207)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_502",
    "data-name": "Rectangle 502",
    width: 13.63,
    height: 1.969,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_892",
    "data-name": "Group 892",
    transform: "translate(0 22.565)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_503",
    "data-name": "Rectangle 503",
    width: 13.63,
    height: 2.122,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_899",
    "data-name": "Group 899",
    transform: "translate(19.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_898",
    "data-name": "Group 898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_895",
    "data-name": "Group 895"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_504",
    "data-name": "Rectangle 504",
    width: 13.63,
    height: 2.122,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_896",
    "data-name": "Group 896",
    transform: "translate(0 11.207)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_505",
    "data-name": "Rectangle 505",
    width: 13.63,
    height: 1.969,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_897",
    "data-name": "Group 897",
    transform: "translate(0 22.565)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_506",
    "data-name": "Rectangle 506",
    width: 13.63,
    height: 2.122,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_907",
    "data-name": "Group 907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_906",
    "data-name": "Group 906"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_901",
    "data-name": "Group 901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_900",
    "data-name": "Group 900"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_507",
    "data-name": "Rectangle 507",
    width: 13.63,
    height: 2.122,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_903",
    "data-name": "Group 903",
    transform: "translate(0 11.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_902",
    "data-name": "Group 902"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_508",
    "data-name": "Rectangle 508",
    width: 13.63,
    height: 1.969,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_905",
    "data-name": "Group 905",
    transform: "translate(0 22.565)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_904",
    "data-name": "Group 904"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_509",
    "data-name": "Rectangle 509",
    width: 13.63,
    height: 2.122,
    fill: "#84c3f7"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_912",
    "data-name": "Group 912",
    transform: "translate(1.179 130.942)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_909",
    "data-name": "Group 909"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_510",
    "data-name": "Rectangle 510",
    width: 11.272,
    height: 8.178,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_511",
    "data-name": "Rectangle 511",
    width: 11.274,
    height: 8.178,
    transform: "translate(19.351)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_512",
    "data-name": "Rectangle 512",
    width: 11.273,
    height: 8.178,
    transform: "translate(38.395)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_513",
    "data-name": "Rectangle 513",
    width: 11.272,
    height: 8.178,
    transform: "translate(57.746)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_514",
    "data-name": "Rectangle 514",
    width: 11.272,
    height: 8.178,
    transform: "translate(76.791)",
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_910",
    "data-name": "Group 910",
    transform: "translate(0 11.056)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_515",
    "data-name": "Rectangle 515",
    width: 11.272,
    height: 8.177,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_516",
    "data-name": "Rectangle 516",
    width: 11.274,
    height: 8.177,
    transform: "translate(19.351)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_517",
    "data-name": "Rectangle 517",
    width: 11.273,
    height: 8.177,
    transform: "translate(38.395)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_518",
    "data-name": "Rectangle 518",
    width: 11.272,
    height: 8.177,
    transform: "translate(57.746)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_519",
    "data-name": "Rectangle 519",
    width: 11.272,
    height: 8.177,
    transform: "translate(76.791)",
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_911",
    "data-name": "Group 911",
    transform: "translate(0 22.565)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_520",
    "data-name": "Rectangle 520",
    width: 11.272,
    height: 8.179,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_521",
    "data-name": "Rectangle 521",
    width: 11.274,
    height: 8.179,
    transform: "translate(19.351)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_522",
    "data-name": "Rectangle 522",
    width: 11.273,
    height: 8.179,
    transform: "translate(38.395)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_523",
    "data-name": "Rectangle 523",
    width: 11.272,
    height: 8.179,
    transform: "translate(57.746)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_524",
    "data-name": "Rectangle 524",
    width: 11.272,
    height: 8.179,
    transform: "translate(76.791)",
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_941",
    "data-name": "Group 941",
    transform: "translate(0 136.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_917",
    "data-name": "Group 917",
    transform: "translate(76.79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_916",
    "data-name": "Group 916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_913",
    "data-name": "Group 913"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_525",
    "data-name": "Rectangle 525",
    width: 13.631,
    height: 2.122,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_914",
    "data-name": "Group 914",
    transform: "translate(0 11.208)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_526",
    "data-name": "Rectangle 526",
    width: 13.631,
    height: 1.969,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_915",
    "data-name": "Group 915",
    transform: "translate(0 22.566)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_527",
    "data-name": "Rectangle 527",
    width: 13.631,
    height: 2.121,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_922",
    "data-name": "Group 922",
    transform: "translate(57.745)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_921",
    "data-name": "Group 921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_918",
    "data-name": "Group 918"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_528",
    "data-name": "Rectangle 528",
    width: 13.631,
    height: 2.122,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_919",
    "data-name": "Group 919",
    transform: "translate(0 11.208)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_529",
    "data-name": "Rectangle 529",
    width: 13.631,
    height: 1.969,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_920",
    "data-name": "Group 920",
    transform: "translate(0 22.566)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_530",
    "data-name": "Rectangle 530",
    width: 13.631,
    height: 2.121,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_927",
    "data-name": "Group 927",
    transform: "translate(38.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_926",
    "data-name": "Group 926"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_923",
    "data-name": "Group 923"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_531",
    "data-name": "Rectangle 531",
    width: 13.63,
    height: 2.122,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_924",
    "data-name": "Group 924",
    transform: "translate(0 11.208)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_532",
    "data-name": "Rectangle 532",
    width: 13.63,
    height: 1.969,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_925",
    "data-name": "Group 925",
    transform: "translate(0 22.566)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_533",
    "data-name": "Rectangle 533",
    width: 13.63,
    height: 2.121,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_932",
    "data-name": "Group 932",
    transform: "translate(19.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_931",
    "data-name": "Group 931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_928",
    "data-name": "Group 928"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_534",
    "data-name": "Rectangle 534",
    width: 13.63,
    height: 2.122,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_929",
    "data-name": "Group 929",
    transform: "translate(0 11.208)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_535",
    "data-name": "Rectangle 535",
    width: 13.63,
    height: 1.969,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_930",
    "data-name": "Group 930",
    transform: "translate(0 22.566)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_536",
    "data-name": "Rectangle 536",
    width: 13.63,
    height: 2.121,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_940",
    "data-name": "Group 940"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_939",
    "data-name": "Group 939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_934",
    "data-name": "Group 934"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_933",
    "data-name": "Group 933"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_537",
    "data-name": "Rectangle 537",
    width: 13.63,
    height: 2.122,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_936",
    "data-name": "Group 936",
    transform: "translate(0 11.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_935",
    "data-name": "Group 935"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_538",
    "data-name": "Rectangle 538",
    width: 13.63,
    height: 1.969,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_938",
    "data-name": "Group 938",
    transform: "translate(0 22.566)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_937",
    "data-name": "Group 937"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_539",
    "data-name": "Rectangle 539",
    width: 13.63,
    height: 2.121,
    fill: "#84c3f7"
  }))))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_540",
    "data-name": "Rectangle 540",
    width: 63.879,
    height: 187.208,
    transform: "translate(202.386 83.607)",
    fill: "#bfcae2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1007",
    "data-name": "Group 1007",
    transform: "translate(211.314 95.66)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1006",
    "data-name": "Group 1006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_973",
    "data-name": "Group 973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_952",
    "data-name": "Group 952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_943",
    "data-name": "Group 943"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_541",
    "data-name": "Rectangle 541",
    width: 12.411,
    height: 5.214,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_944",
    "data-name": "Group 944",
    transform: "translate(0 12.589)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_542",
    "data-name": "Rectangle 542",
    width: 12.411,
    height: 5.214,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_945",
    "data-name": "Group 945",
    transform: "translate(0 25.177)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_543",
    "data-name": "Rectangle 543",
    width: 12.411,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_946",
    "data-name": "Group 946",
    transform: "translate(0 37.765)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_544",
    "data-name": "Rectangle 544",
    width: 12.411,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_947",
    "data-name": "Group 947",
    transform: "translate(0 50.354)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_545",
    "data-name": "Rectangle 545",
    width: 12.411,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_948",
    "data-name": "Group 948",
    transform: "translate(0 62.944)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_546",
    "data-name": "Rectangle 546",
    width: 12.411,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_949",
    "data-name": "Group 949",
    transform: "translate(0 75.532)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_547",
    "data-name": "Rectangle 547",
    width: 12.411,
    height: 5.214,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_950",
    "data-name": "Group 950",
    transform: "translate(0 88.121)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_548",
    "data-name": "Rectangle 548",
    width: 12.411,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_951",
    "data-name": "Group 951",
    transform: "translate(0 100.71)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_549",
    "data-name": "Rectangle 549",
    width: 12.411,
    height: 5.214,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_962",
    "data-name": "Group 962",
    transform: "translate(17.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_953",
    "data-name": "Group 953"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_550",
    "data-name": "Rectangle 550",
    width: 12.41,
    height: 5.214,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_954",
    "data-name": "Group 954",
    transform: "translate(0 12.589)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_551",
    "data-name": "Rectangle 551",
    width: 12.41,
    height: 5.214,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_955",
    "data-name": "Group 955",
    transform: "translate(0 25.177)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_552",
    "data-name": "Rectangle 552",
    width: 12.41,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_956",
    "data-name": "Group 956",
    transform: "translate(0 37.765)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_553",
    "data-name": "Rectangle 553",
    width: 12.41,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_957",
    "data-name": "Group 957",
    transform: "translate(0 50.354)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_554",
    "data-name": "Rectangle 554",
    width: 12.41,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_958",
    "data-name": "Group 958",
    transform: "translate(0 62.944)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_555",
    "data-name": "Rectangle 555",
    width: 12.41,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_959",
    "data-name": "Group 959",
    transform: "translate(0 75.532)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_556",
    "data-name": "Rectangle 556",
    width: 12.41,
    height: 5.214,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_960",
    "data-name": "Group 960",
    transform: "translate(0 88.121)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_557",
    "data-name": "Rectangle 557",
    width: 12.41,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_961",
    "data-name": "Group 961",
    transform: "translate(0 100.71)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_558",
    "data-name": "Rectangle 558",
    width: 12.41,
    height: 5.214,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_972",
    "data-name": "Group 972",
    transform: "translate(35.439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_963",
    "data-name": "Group 963"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_559",
    "data-name": "Rectangle 559",
    width: 12.411,
    height: 5.214,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_964",
    "data-name": "Group 964",
    transform: "translate(0 12.589)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_560",
    "data-name": "Rectangle 560",
    width: 12.411,
    height: 5.214,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_965",
    "data-name": "Group 965",
    transform: "translate(0 25.177)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_561",
    "data-name": "Rectangle 561",
    width: 12.411,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_966",
    "data-name": "Group 966",
    transform: "translate(0 37.765)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_562",
    "data-name": "Rectangle 562",
    width: 12.411,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_967",
    "data-name": "Group 967",
    transform: "translate(0 50.354)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_563",
    "data-name": "Rectangle 563",
    width: 12.411,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_968",
    "data-name": "Group 968",
    transform: "translate(0 62.944)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_564",
    "data-name": "Rectangle 564",
    width: 12.411,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_969",
    "data-name": "Group 969",
    transform: "translate(0 75.532)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_565",
    "data-name": "Rectangle 565",
    width: 12.411,
    height: 5.214,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_970",
    "data-name": "Group 970",
    transform: "translate(0 88.121)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_566",
    "data-name": "Rectangle 566",
    width: 12.411,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_971",
    "data-name": "Group 971",
    transform: "translate(0 100.71)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_567",
    "data-name": "Rectangle 567",
    width: 12.411,
    height: 5.214,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1005",
    "data-name": "Group 1005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1004",
    "data-name": "Group 1004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_983",
    "data-name": "Group 983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_974",
    "data-name": "Group 974"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_568",
    "data-name": "Rectangle 568",
    width: 3.04,
    height: 5.214,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_975",
    "data-name": "Group 975",
    transform: "translate(0 12.589)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_569",
    "data-name": "Rectangle 569",
    width: 3.04,
    height: 5.214,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_976",
    "data-name": "Group 976",
    transform: "translate(0 25.177)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_570",
    "data-name": "Rectangle 570",
    width: 3.04,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_977",
    "data-name": "Group 977",
    transform: "translate(0 37.765)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_571",
    "data-name": "Rectangle 571",
    width: 3.04,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_978",
    "data-name": "Group 978",
    transform: "translate(0 50.354)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_572",
    "data-name": "Rectangle 572",
    width: 3.04,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_979",
    "data-name": "Group 979",
    transform: "translate(0 62.944)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_573",
    "data-name": "Rectangle 573",
    width: 3.04,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_980",
    "data-name": "Group 980",
    transform: "translate(0 75.532)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_574",
    "data-name": "Rectangle 574",
    width: 3.04,
    height: 5.214,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_981",
    "data-name": "Group 981",
    transform: "translate(0 88.121)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_575",
    "data-name": "Rectangle 575",
    width: 3.04,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_982",
    "data-name": "Group 982",
    transform: "translate(0 100.71)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_576",
    "data-name": "Rectangle 576",
    width: 3.04,
    height: 5.214,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_993",
    "data-name": "Group 993",
    transform: "translate(17.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_984",
    "data-name": "Group 984"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_577",
    "data-name": "Rectangle 577",
    width: 3.013,
    height: 5.214,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_985",
    "data-name": "Group 985",
    transform: "translate(0 12.589)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_578",
    "data-name": "Rectangle 578",
    width: 3.013,
    height: 5.214,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_986",
    "data-name": "Group 986",
    transform: "translate(0 25.177)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_579",
    "data-name": "Rectangle 579",
    width: 3.013,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_987",
    "data-name": "Group 987",
    transform: "translate(0 37.765)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_580",
    "data-name": "Rectangle 580",
    width: 3.013,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_988",
    "data-name": "Group 988",
    transform: "translate(0 50.354)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_581",
    "data-name": "Rectangle 581",
    width: 3.013,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_989",
    "data-name": "Group 989",
    transform: "translate(0 62.944)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_582",
    "data-name": "Rectangle 582",
    width: 3.013,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_990",
    "data-name": "Group 990",
    transform: "translate(0 75.532)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_583",
    "data-name": "Rectangle 583",
    width: 3.013,
    height: 5.214,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_991",
    "data-name": "Group 991",
    transform: "translate(0 88.121)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_584",
    "data-name": "Rectangle 584",
    width: 3.013,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_992",
    "data-name": "Group 992",
    transform: "translate(0 100.71)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_585",
    "data-name": "Rectangle 585",
    width: 3.013,
    height: 5.214,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1003",
    "data-name": "Group 1003",
    transform: "translate(35.439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_994",
    "data-name": "Group 994"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_586",
    "data-name": "Rectangle 586",
    width: 2.823,
    height: 5.214,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_995",
    "data-name": "Group 995",
    transform: "translate(0 12.589)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_587",
    "data-name": "Rectangle 587",
    width: 2.823,
    height: 5.214,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_996",
    "data-name": "Group 996",
    transform: "translate(0 25.177)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_588",
    "data-name": "Rectangle 588",
    width: 2.823,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_997",
    "data-name": "Group 997",
    transform: "translate(0 37.765)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_589",
    "data-name": "Rectangle 589",
    width: 2.823,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_998",
    "data-name": "Group 998",
    transform: "translate(0 50.354)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_590",
    "data-name": "Rectangle 590",
    width: 2.823,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_999",
    "data-name": "Group 999",
    transform: "translate(0 62.944)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_591",
    "data-name": "Rectangle 591",
    width: 2.823,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1000",
    "data-name": "Group 1000",
    transform: "translate(0 75.532)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_592",
    "data-name": "Rectangle 592",
    width: 2.823,
    height: 5.214,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1001",
    "data-name": "Group 1001",
    transform: "translate(0 88.121)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_593",
    "data-name": "Rectangle 593",
    width: 2.823,
    height: 5.215,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1002",
    "data-name": "Group 1002",
    transform: "translate(0 100.71)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_594",
    "data-name": "Rectangle 594",
    width: 2.823,
    height: 5.214,
    fill: "#84c3f7"
  }))))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_595",
    "data-name": "Rectangle 595",
    width: 74.963,
    height: 118.267,
    transform: "translate(283.669 152.549)",
    fill: "#abb8d8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1024",
    "data-name": "Group 1024",
    transform: "translate(298.698 170.084)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1023",
    "data-name": "Group 1023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1012",
    "data-name": "Group 1012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1008",
    "data-name": "Group 1008"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_596",
    "data-name": "Rectangle 596",
    width: 9.216,
    height: 17.781,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1009",
    "data-name": "Group 1009",
    transform: "translate(0 26.352)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_597",
    "data-name": "Rectangle 597",
    width: 9.216,
    height: 17.78,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1010",
    "data-name": "Group 1010",
    transform: "translate(0 52.701)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_598",
    "data-name": "Rectangle 598",
    width: 9.216,
    height: 17.779,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1011",
    "data-name": "Group 1011",
    transform: "translate(0 79.05)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_599",
    "data-name": "Rectangle 599",
    width: 9.216,
    height: 17.78,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1017",
    "data-name": "Group 1017",
    transform: "translate(18.987 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1013",
    "data-name": "Group 1013"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_600",
    "data-name": "Rectangle 600",
    width: 9.216,
    height: 17.779,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1014",
    "data-name": "Group 1014",
    transform: "translate(0 26.35)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_601",
    "data-name": "Rectangle 601",
    width: 9.216,
    height: 17.78,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1015",
    "data-name": "Group 1015",
    transform: "translate(0 52.699)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_602",
    "data-name": "Rectangle 602",
    width: 9.216,
    height: 17.779,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1016",
    "data-name": "Group 1016",
    transform: "translate(0 79.05)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_603",
    "data-name": "Rectangle 603",
    width: 9.216,
    height: 17.78,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1022",
    "data-name": "Group 1022",
    transform: "translate(37.976 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1018",
    "data-name": "Group 1018"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_604",
    "data-name": "Rectangle 604",
    width: 9.215,
    height: 17.779,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1019",
    "data-name": "Group 1019",
    transform: "translate(0 26.35)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_605",
    "data-name": "Rectangle 605",
    width: 9.215,
    height: 17.78,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1020",
    "data-name": "Group 1020",
    transform: "translate(0 52.699)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_606",
    "data-name": "Rectangle 606",
    width: 9.215,
    height: 17.779,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1021",
    "data-name": "Group 1021",
    transform: "translate(0 79.05)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_607",
    "data-name": "Rectangle 607",
    width: 9.215,
    height: 17.78,
    fill: "#84c3f7"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M117.578,2008.985H43.912v6.438h1.741v87.351H115.2v-87.351h2.375Z",
    transform: "translate(-43.912 -1831.958)",
    fill: "#bfcae2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1025",
    "data-name": "Group 1025",
    transform: "translate(12.245 199.667)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_608",
    "data-name": "Rectangle 608",
    width: 43.07,
    height: 8.156,
    transform: "translate(2.082 1.007)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_609",
    "data-name": "Rectangle 609",
    width: 43.07,
    height: 8.156,
    transform: "translate(2.082 13.096)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_610",
    "data-name": "Rectangle 610",
    width: 43.07,
    height: 8.155,
    transform: "translate(2.082 25.184)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_611",
    "data-name": "Rectangle 611",
    width: 43.07,
    height: 8.157,
    transform: "translate(2.082 37.272)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_612",
    "data-name": "Rectangle 612",
    width: 43.07,
    height: 8.156,
    transform: "translate(2.082 61.45)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_613",
    "data-name": "Rectangle 613",
    width: 43.07,
    height: 8.157,
    transform: "translate(2.082 49.361)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_614",
    "data-name": "Rectangle 614",
    width: 2.082,
    height: 70.912,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_615",
    "data-name": "Rectangle 615",
    width: 2.082,
    height: 70.912,
    transform: "translate(44.112 0.236)",
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M171.583,2042.644H68.431v6.438h2.5V2091.1h96.919v-42.021h3.731Z",
    transform: "translate(-35.409 -1820.286)",
    fill: "#abb8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M254.489,2053.928v-58.776H187.975v58.776H160.66v53.642H281.8v-53.642Z",
    transform: "translate(-3.427 -1836.755)",
    fill: "#abb8d8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1036",
    "data-name": "Group 1036",
    transform: "translate(171.498 167.786)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1035",
    "data-name": "Group 1035"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1026",
    "data-name": "Group 1026",
    transform: "translate(0 66.837)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_616",
    "data-name": "Rectangle 616",
    width: 92.614,
    height: 12.459,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1027",
    "data-name": "Group 1027",
    transform: "translate(0 85.3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_617",
    "data-name": "Rectangle 617",
    width: 92.614,
    height: 12.459,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1031",
    "data-name": "Group 1031",
    transform: "translate(25.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1028",
    "data-name": "Group 1028"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_618",
    "data-name": "Rectangle 618",
    width: 42.435,
    height: 12.46,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1029",
    "data-name": "Group 1029",
    transform: "translate(0 18.464)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_619",
    "data-name": "Rectangle 619",
    width: 42.435,
    height: 12.46,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1030",
    "data-name": "Group 1030",
    transform: "translate(0 36.93)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_620",
    "data-name": "Rectangle 620",
    width: 42.435,
    height: 12.458,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1032",
    "data-name": "Group 1032",
    transform: "translate(21.804 48.063)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_621",
    "data-name": "Rectangle 621",
    width: 49.212,
    height: 2.651,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1033",
    "data-name": "Group 1033",
    transform: "translate(21.804 29.598)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_622",
    "data-name": "Rectangle 622",
    width: 49.212,
    height: 2.652,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1034",
    "data-name": "Group 1034",
    transform: "translate(21.804 11.134)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_623",
    "data-name": "Rectangle 623",
    width: 49.212,
    height: 2.651,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1040",
    "data-name": "Group 1040",
    transform: "translate(45.027 229.975)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1037",
    "data-name": "Group 1037"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_624",
    "data-name": "Rectangle 624",
    width: 9.92,
    height: 8.643,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_625",
    "data-name": "Rectangle 625",
    width: 9.922,
    height: 8.643,
    transform: "translate(17.031)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_626",
    "data-name": "Rectangle 626",
    width: 9.921,
    height: 8.643,
    transform: "translate(33.791)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_627",
    "data-name": "Rectangle 627",
    width: 9.92,
    height: 8.643,
    transform: "translate(50.821)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_628",
    "data-name": "Rectangle 628",
    width: 9.92,
    height: 8.643,
    transform: "translate(67.582)",
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1038",
    "data-name": "Group 1038",
    transform: "translate(0 11.684)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_629",
    "data-name": "Rectangle 629",
    width: 9.92,
    height: 8.641,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_630",
    "data-name": "Rectangle 630",
    width: 9.922,
    height: 8.641,
    transform: "translate(17.031)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_631",
    "data-name": "Rectangle 631",
    width: 9.921,
    height: 8.641,
    transform: "translate(33.791)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_632",
    "data-name": "Rectangle 632",
    width: 9.92,
    height: 8.641,
    transform: "translate(50.821)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_633",
    "data-name": "Rectangle 633",
    width: 9.92,
    height: 8.641,
    transform: "translate(67.582)",
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1039",
    "data-name": "Group 1039",
    transform: "translate(0 23.846)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_634",
    "data-name": "Rectangle 634",
    width: 9.92,
    height: 8.644,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_635",
    "data-name": "Rectangle 635",
    width: 9.922,
    height: 8.644,
    transform: "translate(17.031)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_636",
    "data-name": "Rectangle 636",
    width: 9.921,
    height: 8.644,
    transform: "translate(33.791)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_637",
    "data-name": "Rectangle 637",
    width: 9.92,
    height: 8.644,
    transform: "translate(50.821)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_638",
    "data-name": "Rectangle 638",
    width: 9.92,
    height: 8.644,
    transform: "translate(67.582)",
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1070",
    "data-name": "Group 1070",
    transform: "translate(44.08 236.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1069",
    "data-name": "Group 1069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1045",
    "data-name": "Group 1045",
    transform: "translate(67.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1044",
    "data-name": "Group 1044"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1041",
    "data-name": "Group 1041"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_639",
    "data-name": "Rectangle 639",
    width: 12.006,
    height: 2.234,
    fill: "#a3cbe5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1042",
    "data-name": "Group 1042",
    transform: "translate(0 11.801)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_640",
    "data-name": "Rectangle 640",
    width: 12.006,
    height: 2.073,
    fill: "#a3cbe5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1043",
    "data-name": "Group 1043",
    transform: "translate(0 23.761)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_641",
    "data-name": "Rectangle 641",
    width: 12.006,
    height: 2.233,
    fill: "#a3cbe5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1050",
    "data-name": "Group 1050",
    transform: "translate(50.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1049",
    "data-name": "Group 1049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1046",
    "data-name": "Group 1046"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_642",
    "data-name": "Rectangle 642",
    width: 12.006,
    height: 2.234,
    fill: "#a3cbe5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1047",
    "data-name": "Group 1047",
    transform: "translate(0 11.801)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_643",
    "data-name": "Rectangle 643",
    width: 12.006,
    height: 2.073,
    fill: "#a3cbe5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1048",
    "data-name": "Group 1048",
    transform: "translate(0 23.761)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_644",
    "data-name": "Rectangle 644",
    width: 12.006,
    height: 2.233,
    fill: "#a3cbe5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1055",
    "data-name": "Group 1055",
    transform: "translate(33.818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1054",
    "data-name": "Group 1054"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1051",
    "data-name": "Group 1051"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_645",
    "data-name": "Rectangle 645",
    width: 12.006,
    height: 2.234,
    fill: "#a3cbe5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1052",
    "data-name": "Group 1052",
    transform: "translate(0 11.801)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_646",
    "data-name": "Rectangle 646",
    width: 12.006,
    height: 2.073,
    fill: "#a3cbe5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1053",
    "data-name": "Group 1053",
    transform: "translate(0 23.761)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_647",
    "data-name": "Rectangle 647",
    width: 12.006,
    height: 2.233,
    fill: "#a3cbe5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1060",
    "data-name": "Group 1060",
    transform: "translate(17.046)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1059",
    "data-name": "Group 1059"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1056",
    "data-name": "Group 1056"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_648",
    "data-name": "Rectangle 648",
    width: 12.006,
    height: 2.234,
    fill: "#a3cbe5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1057",
    "data-name": "Group 1057",
    transform: "translate(0 11.801)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_649",
    "data-name": "Rectangle 649",
    width: 12.006,
    height: 2.073,
    fill: "#a3cbe5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1058",
    "data-name": "Group 1058",
    transform: "translate(0 23.761)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_650",
    "data-name": "Rectangle 650",
    width: 12.006,
    height: 2.233,
    fill: "#a3cbe5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1068",
    "data-name": "Group 1068"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1067",
    "data-name": "Group 1067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1062",
    "data-name": "Group 1062"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1061",
    "data-name": "Group 1061"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_651",
    "data-name": "Rectangle 651",
    width: 12.006,
    height: 2.234,
    fill: "#a3cbe5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1064",
    "data-name": "Group 1064",
    transform: "translate(0 11.801)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1063",
    "data-name": "Group 1063"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_652",
    "data-name": "Rectangle 652",
    width: 12.006,
    height: 2.073,
    fill: "#a3cbe5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1066",
    "data-name": "Group 1066",
    transform: "translate(0 23.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1065",
    "data-name": "Group 1065"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_653",
    "data-name": "Rectangle 653",
    width: 12.006,
    height: 2.233,
    fill: "#a3cbe5"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1076",
    "data-name": "Group 1076",
    transform: "translate(330.613 1883.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M310.038,1985.018c22.962-2.861,35.691-17.189,40.11-24.157a7.312,7.312,0,0,0,.524-6.8c-4.524-10.588-10.974-21.427-15.6-26.049-3.075-3.041-3.092-5.3-2.966-6.543l.52-5.041c.889-6.986-18.662-3.934-18.324-.231,0,0,.725,5.825-3.448,6.279l-8.486.921c-4.172.453-4.714-5.393-4.714-5.393-.466-3.689-20.215-2.472-17.849,4.159l1.589,4.812c.391,1.183.714,3.425-1.325,6.285l-.012.022c-3.988,5.76-7.166,16.055-10.192,31.362a4.811,4.811,0,0,0,.847,3.8C274.85,1974.036,289.472,1987.58,310.038,1985.018Z",
    transform: "translate(-252.291 -1826.685)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M283.729,1911.3",
    transform: "translate(-247.45 -1827.012)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1072",
    "data-name": "Group 1072",
    transform: "translate(0 9.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M256.811,1862.553c.471-20.234,26,7.383,35.587,34.387,5.289,14.892,11.744,51.383,11.744,51.383l-13.282,4.265S255.844,1904.013,256.811,1862.553Z",
    transform: "translate(-256.791 -1855.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M263.042,1874.225c.042-14.079,17.231,5.485,23.911,24.411,3.141,8.9,7.049,28.742,8.132,34.4a3.4,3.4,0,0,1-.843,2.847h0c-1.8,2.085-5.263,2.112-6.654.055C280.464,1925.405,262.973,1897.2,263.042,1874.225Z",
    transform: "translate(-254.624 -1850.782)",
    fill: "#d6d6d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1073",
    "data-name": "Group 1073",
    transform: "translate(60.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M327.095,1854.478c-5.821-19.384-23.108,14.012-25.194,42.593-1.15,15.761,2.3,52.657,2.3,52.657l13.936.591S339.022,1894.2,327.095,1854.478Z",
    transform: "translate(-301.666 -1848.715)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M321.935,1867.559c-3.762-13.857-15.169,10.087-16.608,30.548-.614,8.726.541,26.492,1.1,34.095a4.382,4.382,0,0,0,4.4,3.759h0a4.5,4.5,0,0,0,4.559-2.8C318.7,1923.394,328.392,1891.348,321.935,1867.559Z",
    transform: "translate(-300.457 -1843.606)",
    fill: "#d6d6d4"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_522",
    "data-name": "Ellipse 522",
    cx: 9.627,
    cy: 12.196,
    rx: 9.627,
    ry: 12.196,
    transform: "translate(30.167 121.903) rotate(-6.196)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_523",
    "data-name": "Ellipse 523",
    cx: 9.627,
    cy: 12.196,
    rx: 9.627,
    ry: 12.196,
    transform: "translate(64.615 118.163) rotate(-6.196)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1074",
    "data-name": "Group 1074",
    transform: "translate(33.813 124.319)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_524",
    "data-name": "Ellipse 524",
    cx: 6.413,
    cy: 8.024,
    rx: 6.413,
    ry: 8.024,
    transform: "translate(0 1.384) rotate(-6.196)",
    fill: "#572680"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_525",
    "data-name": "Ellipse 525",
    cx: 2.432,
    cy: 2.918,
    rx: 2.432,
    ry: 2.918,
    transform: "translate(4.561 6.502) rotate(-6.196)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1075",
    "data-name": "Group 1075",
    transform: "translate(68.26 120.579)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_526",
    "data-name": "Ellipse 526",
    cx: 6.413,
    cy: 8.024,
    rx: 6.413,
    ry: 8.024,
    transform: "translate(0 1.384) rotate(-6.196)",
    fill: "#572680"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_527",
    "data-name": "Ellipse 527",
    cx: 2.432,
    cy: 2.918,
    rx: 2.432,
    ry: 2.918,
    transform: "translate(4.561 6.502) rotate(-6.196)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M327.261,2006.633a10.774,10.774,0,0,1-6.47-19.348c45.151-34.372,49.925-86.082,49.968-86.6a10.774,10.774,0,0,1,21.474,1.781c-.207,2.506-5.693,61.846-58.389,101.966A10.739,10.739,0,0,1,327.261,2006.633Z",
    transform: "translate(94.541 49.796)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_654",
    "data-name": "Rectangle 654",
    width: 6.7,
    height: 16.575,
    rx: 2.294,
    transform: "translate(333.175 1995.389) rotate(22.723)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1081",
    "data-name": "Group 1081",
    transform: "translate(187.189 2001.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1077",
    "data-name": "Group 1077",
    transform: "translate(308.177 47.641)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_655",
    "data-name": "Rectangle 655",
    width: 42.7,
    height: 25.144,
    fill: "#a0771c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_656",
    "data-name": "Rectangle 656",
    width: 111.357,
    height: 25.144,
    transform: "translate(42.7)",
    fill: "#e59405"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M511.758,1984.795l-91.833.2-9.1-13.9H522.185Z",
    transform: "translate(-368.128 -1971.09)",
    fill: "#c68318"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M420.871,1977.716l-5.154,6.556,0,0-.242.311.511-.1-.076.442.432-.162-.05.463.432-.162-.066.45.432-.162-.092.43.427-.166-.066.45.422-.17-.045.467.427-.166-.034.475.453-.145.022.519.244-.31.289-.368,4.865-6.188Z",
    transform: "translate(-366.516 -1968.792)",
    fill: "#e6e6e6",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M482.519,1980.839l5.818,5.975,0,0,.277.281-.031-.52.428.134-.1-.45.452.11-.1-.45.438.125-.1-.45.414.148-.108-.446.438.125-.113-.441.457.106-.108-.445.466.1-.084-.469.518.047-.275-.283-.327-.335-5.491-5.64Z",
    transform: "translate(-343.268 -1968.674)",
    fill: "#e6e6e6",
    opacity: 0.45
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_657",
    "data-name": "Rectangle 657",
    width: 26.764,
    height: 119.429,
    transform: "translate(307.215 72.785)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_658",
    "data-name": "Rectangle 658",
    width: 23.153,
    height: 25.144,
    transform: "translate(307.215 47.641)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1078",
    "data-name": "Group 1078",
    transform: "translate(314.934 72.785)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_659",
    "data-name": "Rectangle 659",
    width: 172.793,
    height: 119.671,
    transform: "translate(0)",
    fill: "#f1b776"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_660",
    "data-name": "Rectangle 660",
    width: 45.551,
    height: 119.671,
    transform: "translate(0)",
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_661",
    "data-name": "Rectangle 661",
    width: 20.073,
    height: 8.237,
    transform: "translate(138.525 98.885)",
    fill: "#faffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_662",
    "data-name": "Rectangle 662",
    width: 8.237,
    height: 8.237,
    transform: "translate(58.711 98.885)",
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_663",
    "data-name": "Rectangle 663",
    width: 8.237,
    height: 8.237,
    transform: "translate(69.988 98.885)",
    fill: "#a55927"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1079",
    "data-name": "Group 1079",
    transform: "translate(0 72.785)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_664",
    "data-name": "Rectangle 664",
    width: 172.793,
    height: 119.671,
    fill: "#f1b776"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_665",
    "data-name": "Rectangle 665",
    width: 45.551,
    height: 119.671,
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_666",
    "data-name": "Rectangle 666",
    width: 20.073,
    height: 8.237,
    transform: "translate(138.525 98.885)",
    fill: "#faffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_667",
    "data-name": "Rectangle 667",
    width: 8.237,
    height: 8.237,
    transform: "translate(58.711 98.885)",
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_668",
    "data-name": "Rectangle 668",
    width: 8.237,
    height: 8.237,
    transform: "translate(69.988 98.885)",
    fill: "#a55927"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_669",
    "data-name": "Rectangle 669",
    width: 18.733,
    height: 119.793,
    transform: "translate(93.533 72.664)",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1080",
    "data-name": "Group 1080",
    transform: "translate(103.897)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_670",
    "data-name": "Rectangle 670",
    width: 220.951,
    height: 192.456,
    transform: "translate(10.512)",
    fill: "#f1b776"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_671",
    "data-name": "Rectangle 671",
    width: 83.767,
    height: 192.456,
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_672",
    "data-name": "Rectangle 672",
    width: 32.281,
    height: 13.246,
    transform: "translate(176.976 159.027)",
    fill: "#faffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_673",
    "data-name": "Rectangle 673",
    width: 13.246,
    height: 13.246,
    transform: "translate(104.932 159.027)",
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_674",
    "data-name": "Rectangle 674",
    width: 13.246,
    height: 13.246,
    transform: "translate(123.067 159.027)",
    fill: "#a55927"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_528",
    "data-name": "Ellipse 528",
    cx: 11.109,
    cy: 9.485,
    rx: 11.109,
    ry: 9.485,
    transform: "translate(311.349 1991.739)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_529",
    "data-name": "Ellipse 529",
    cx: 11.109,
    cy: 9.485,
    rx: 11.109,
    ry: 9.485,
    transform: "translate(311.349 1990.393)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1082",
    "data-name": "Group 1082",
    transform: "translate(460.059 1938.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M362.039,1928.579a10.688,10.688,0,0,0,13.644-7.442,116.656,116.656,0,0,0,3.4-18.149c.492-5.93-2.541-13.159-8.473-13.651s-11.963,3.476-13,11.87a99.455,99.455,0,0,1-2.777,14.409,10.672,10.672,0,0,0,6.984,12.89Z",
    transform: "translate(-352.363 -1889.296)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_675",
    "data-name": "Rectangle 675",
    width: 6.7,
    height: 16.575,
    rx: 3.35,
    transform: "matrix(0.974, -0.227, 0.227, 0.974, 0, 10.126)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M390,1958.513a2.693,2.693,0,0,1-2.649-1.615l-50.173-115.508a2.694,2.694,0,0,1,4.943-2.147l50.171,115.509a2.693,2.693,0,0,1-2.292,3.76Z",
    transform: "translate(101.62 31.356)",
    fill: "#9a4dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M372.572,1916.432c-6.446,1.192-12.292-1.487-14.52-8.931-1.749-6.617.236-13.117,3.746-13.9,7.322-1.633,16.755-2.1,18.612,8.514C381.771,1909.894,380.355,1914.993,372.572,1916.432Z",
    transform: "translate(108.738 50.459)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M372.677,1917.769c-6.429,1.278-12.907-4.388-14.28-12.166-.94-5.324.292-10.092,2.6-10.808,3.265-.114,4.393-2.21,4.333-3.356a2.864,2.864,0,0,1,2.247-1.976l.027,0c4.592-.834,12.528,1.642,14.386,12.26C383.347,1909.5,380.539,1916.207,372.677,1917.769Z",
    transform: "translate(108.909 49.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M268.166,2087.753v-35.214l-1.736,1.584-1.053-1.622-1.231,1.592-1.221-1.624-1.231,1.591-1.121-1.623-1.231,1.592-.953-1.621-1.2,1.592-1.121-1.623-1.163,1.593-1.255-1.625-1.2,1.592-1.324-1.625-1.365,1.59-1.684-1.63-.025,35.482Z",
    transform: "translate(70.793 105.79)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1083",
    "data-name": "Group 1083",
    transform: "translate(448.606 1829.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M344.4,1849.618l25,59.39,40.058-32.705,6.2,17.31,40.524-28.347a2.729,2.729,0,0,0,.83-3.193l-19.891-51.25a2.131,2.131,0,0,0-3.145-1.238l-26.02,17.128-5.638-16.57a2.2,2.2,0,0,0-3.382-1.312Z",
    transform: "translate(-344.403 -1808.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M398.96,1809.385l-54.418,40.693,24.813,58.745,52.151-42.578-18.984-55.478A2.315,2.315,0,0,0,398.96,1809.385Z",
    transform: "translate(-344.355 -1808.237)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M398.914,1878.676l5.889-27.183-12.093,9.873Z",
    transform: "translate(-327.651 -1793.484)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M348.654,1846.106l10.354,24.764,27.23-21.253-9.222-24.969Z",
    transform: "translate(-342.929 -1802.794)",
    fill: "#262f82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M369.713,1829.369l24.419-18.333,1.242,3.631-24.408,18.1Z",
    transform: "translate(-335.626 -1807.515)",
    fill: "#ff4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M371.811,1835.017l24.256-18.2,1.243,3.632-24.243,17.973Z",
    transform: "translate(-334.899 -1805.511)",
    fill: "#ff4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M373.7,1840.1,397.8,1822l1.243,3.633L374.954,1843.5Z",
    transform: "translate(-334.244 -1803.711)",
    fill: "#ff4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M375.627,1845.29l23.956-17.979,1.243,3.634-23.942,17.75Z",
    transform: "translate(-333.575 -1801.871)",
    fill: "#ff4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M357.377,1871.057l51.04-38.307,1.31,3.829-50.694,38.594Z",
    transform: "translate(-339.904 -1799.985)",
    fill: "#ff4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M359.7,1876.573l50.56-38.091,1.243,3.633-49.846,39.066Z",
    transform: "translate(-339.1 -1797.997)",
    fill: "#ff4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M362.426,1883.094l49.632-38.646,1.307,3.819-49.107,39.03Z",
    transform: "translate(-338.153 -1795.928)",
    fill: "#ff4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M393.028,1830.477l24.549-16.623,1.331,3.571-24.691,16.51Z",
    transform: "translate(-327.541 -1806.537)",
    fill: "#ff4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M394.933,1836.017l24.577-16.642,1.352,3.557-24.752,16.55Z",
    transform: "translate(-326.881 -1804.622)",
    fill: "#ff4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M396.74,1841.329l24.82-16.807,1.409,3.521-25.051,16.75Z",
    transform: "translate(-326.254 -1802.838)",
    fill: "#ff4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M398.548,1846.645l25.086-16.986,1.356,3.559-25.263,16.892Z",
    transform: "translate(-325.627 -1801.057)",
    fill: "#ff4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M400.34,1851.964l25.312-17.14,1.409,3.526-25.537,17.075Z",
    transform: "translate(-325.005 -1799.265)",
    fill: "#ff4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M401.55,1858.058l26.645-18.043,1.384,3.543-29.1,19.461Z",
    transform: "translate(-324.959 -1797.465)",
    fill: "#ff4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M399.859,1866.739l31.673-21.165,1.349,3.567-34.158,22.839Z",
    transform: "translate(-325.566 -1795.537)",
    fill: "#ff4d4d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1084",
    "data-name": "Group 1084",
    transform: "translate(460.529 1862.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M372.421,1841.844a.764.764,0,0,0-1.135-.245,1,1,0,0,0-.412,1.234.763.763,0,0,0,1.135.245A1,1,0,0,0,372.421,1841.844Z",
    transform: "translate(-347.175 -1829.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M367.944,1843.735a1,1,0,0,0-.411,1.232.763.763,0,0,0,1.135.245,1,1,0,0,0,.411-1.232A.763.763,0,0,0,367.944,1843.735Z",
    transform: "translate(-348.334 -1829.238)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M364.6,1845.871a1,1,0,0,0-.412,1.232.764.764,0,0,0,1.135.245,1,1,0,0,0,.412-1.234A.762.762,0,0,0,364.6,1845.871Z",
    transform: "translate(-349.492 -1828.498)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M361.261,1848.006a1,1,0,0,0-.411,1.234.762.762,0,0,0,1.135.244,1,1,0,0,0,.411-1.232A.762.762,0,0,0,361.261,1848.006Z",
    transform: "translate(-350.651 -1827.757)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M357.92,1850.142a1,1,0,0,0-.412,1.232.764.764,0,0,0,1.135.245,1,1,0,0,0,.412-1.234A.762.762,0,0,0,357.92,1850.142Z",
    transform: "translate(-351.81 -1827.016)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M368.607,1840.609a1,1,0,0,0-.412,1.234.764.764,0,0,0,1.135.244,1,1,0,0,0,.412-1.234A.763.763,0,0,0,368.607,1840.609Z",
    transform: "translate(-348.104 -1830.322)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M365.265,1842.745a1,1,0,0,0-.411,1.232.762.762,0,0,0,1.135.244,1,1,0,0,0,.411-1.232A.762.762,0,0,0,365.265,1842.745Z",
    transform: "translate(-349.263 -1829.582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M361.924,1844.88a1,1,0,0,0-.412,1.233.762.762,0,0,0,1.135.245,1,1,0,0,0,.412-1.233A.762.762,0,0,0,361.924,1844.88Z",
    transform: "translate(-350.422 -1828.841)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M358.583,1847.015a1,1,0,0,0-.412,1.234.763.763,0,0,0,1.135.245,1,1,0,0,0,.411-1.234A.762.762,0,0,0,358.583,1847.015Z",
    transform: "translate(-351.58 -1828.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M367.637,1836.557a.762.762,0,0,0-1.134-.245,1,1,0,0,0-.412,1.234.762.762,0,0,0,1.135.244A1,1,0,0,0,367.637,1836.557Z",
    transform: "translate(-348.834 -1831.812)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M364.3,1838.691a.762.762,0,0,0-1.135-.243,1,1,0,0,0-.411,1.232.762.762,0,0,0,1.134.245A1,1,0,0,0,364.3,1838.691Z",
    transform: "translate(-349.992 -1831.072)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M360.955,1840.828a.763.763,0,0,0-1.135-.245,1,1,0,0,0-.412,1.234.762.762,0,0,0,1.135.244A1,1,0,0,0,360.955,1840.828Z",
    transform: "translate(-351.151 -1830.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M357.613,1842.963a.762.762,0,0,0-1.135-.244,1,1,0,0,0-.411,1.232.763.763,0,0,0,1.135.245A1,1,0,0,0,357.613,1842.963Z",
    transform: "translate(-352.31 -1829.591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M369.2,1837.341a1,1,0,0,0-.411,1.234.762.762,0,0,0,1.135.244,1,1,0,0,0,.411-1.232A.763.763,0,0,0,369.2,1837.341Z",
    transform: "translate(-347.898 -1831.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M365.859,1839.477a1,1,0,0,0-.412,1.233.764.764,0,0,0,1.135.245,1,1,0,0,0,.412-1.234A.763.763,0,0,0,365.859,1839.477Z",
    transform: "translate(-349.057 -1830.715)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M362.517,1841.611a1,1,0,0,0-.411,1.234.762.762,0,0,0,1.135.244,1,1,0,0,0,.411-1.232A.763.763,0,0,0,362.517,1841.611Z",
    transform: "translate(-350.216 -1829.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M359.176,1843.748a1,1,0,0,0-.412,1.232.763.763,0,0,0,1.135.245,1,1,0,0,0,.412-1.234A.763.763,0,0,0,359.176,1843.748Z",
    transform: "translate(-351.374 -1829.234)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M355.834,1845.882a1,1,0,0,0-.411,1.234.762.762,0,0,0,1.135.244,1,1,0,0,0,.411-1.233A.763.763,0,0,0,355.834,1845.882Z",
    transform: "translate(-352.533 -1828.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M367.838,1834.56a1,1,0,0,0,.412-1.234.762.762,0,0,0-1.135-.244,1,1,0,0,0-.412,1.232A.763.763,0,0,0,367.838,1834.56Z",
    transform: "translate(-348.621 -1832.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M364.5,1836.7a1,1,0,0,0,.412-1.232.762.762,0,0,0-1.135-.245,1,1,0,0,0-.411,1.232A.76.76,0,0,0,364.5,1836.7Z",
    transform: "translate(-349.78 -1832.192)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M361.155,1838.831a1,1,0,0,0,.412-1.234.763.763,0,0,0-1.135-.244,1,1,0,0,0-.412,1.232A.764.764,0,0,0,361.155,1838.831Z",
    transform: "translate(-350.939 -1831.451)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M357.813,1840.966a1,1,0,0,0,.412-1.232.763.763,0,0,0-1.135-.245,1,1,0,0,0-.411,1.234A.761.761,0,0,0,357.813,1840.966Z",
    transform: "translate(-352.098 -1830.711)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M354.884,1841.869a.762.762,0,0,0-1.135-.244,1,1,0,0,0-.412,1.232.763.763,0,0,0,1.135.245A1,1,0,0,0,354.884,1841.869Z",
    transform: "translate(-353.256 -1829.97)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1085",
    "data-name": "Group 1085",
    transform: "translate(399.261 1830.258)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    y1: 5.893,
    x2: 3.208,
    transform: "translate(19.376)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x2: 8.622,
    y2: 0.656,
    transform: "translate(21.161 13.714)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    x2: 3.982,
    y2: 5.216,
    transform: "translate(19.825 22.976)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    x1: 4.309,
    y2: 7.281,
    transform: "translate(7.338 22.218)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    x1: 8.607,
    y2: 0.857,
    transform: "translate(0 14.854)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    x1: 3.407,
    y1: 5.918,
    transform: "translate(6.528 0.335)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1086",
    "data-name": "Group 1086",
    transform: "translate(553.151 1986.337)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    y1: 5.893,
    x2: 3.208,
    transform: "translate(19.376)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    x2: 8.622,
    y2: 0.656,
    transform: "translate(21.161 13.714)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    x2: 3.982,
    y2: 5.216,
    transform: "translate(19.825 22.976)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    x1: 4.309,
    y2: 7.281,
    transform: "translate(7.338 22.219)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    x1: 8.607,
    y2: 0.857,
    transform: "translate(0 14.854)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    x1: 3.407,
    y1: 5.918,
    transform: "translate(6.528 0.335)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1087",
    "data-name": "Group 1087",
    transform: "translate(578.878 1898.43)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    y1: 8.63,
    x2: 4.458,
    transform: "translate(28.127)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    x2: 13.283,
    y2: 0.884,
    transform: "translate(32.601 18.824)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    x2: 6.064,
    y2: 7.429,
    transform: "translate(29.232 31.105)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    x1: 4.178,
    y2: 11.218,
    transform: "translate(13.154 29.581)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    x1: 13.259,
    y2: 1.155,
    transform: "translate(0 20.361)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    x1: 5.993,
    y1: 7.906,
    transform: "translate(10.304 0.83)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner1);
export default __webpack_public_path__ + "static/media/banner-1.75232ba102633056b2709ca31a44e69d.svg";
export { ForwardRef as ReactComponent };